<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <v-card class="pa-2">
          <!-- Título -->
          <v-toolbar color="light-blue" class="ma-2"
            style="color: white;display:flex;flex-direction:column;padding-top:5px;padding-bottom:5px;">
            <div style="min-width:100%!important;display:flex;justify-content:space-between;">
              <span class="toolbar-title"> 
                Pagamentos Check-In 
              </span> 
              <span style="width:5%;"> 
                <BotaoTutorial style="margin-right:30px;margin-left:15px;" urlVideo="" categoria="" legenda="Dúvidas Pagamentos Check-In "/>
              </span>
              </div>
          </v-toolbar>
          <br>
          <!-- Filtro -->
          <v-row style="max-width: 100%;display:flex;align-items:center;justify-content:center;">
            <!-- Nome -->
            <v-text-field class="mr-2" type="text" label="Nome" 
              v-model="filtroNome"
              data-cy="input-nome-filtro"
              style="max-width:120px!important;"
            ></v-text-field>
            <!-- Sobrenome -->
            <v-text-field class="mr-2" type="text" label="Sobrenome"
              v-model="filtroSobrenome"
              data-cy="input-sobrenome-filtro"
              style="max-width:120px!important;"
            ></v-text-field>
            <!-- Reserva -->
            <v-text-field class="ml-5 mr-2" type="text" label="Reserva"
              v-model="filtroReserva"
              data-cy="input-reserva-filtro"
              style="max-width:120px!important;"
            ></v-text-field>
            <!-- Status -->
                  <v-select
                    class="mr-2"
                    type="text"
                    label="Status"
                    v-model="filtroStatusPagto"
                    :items="listadestatus"
                    item-value="id"
                    item-text="nome"
                    return-object
                    style="max-width:100px!important;"
                    data-cy="input-status-filtro"
                  >
                  </v-select>
            <!-- Data Inicial -->
            <v-text-field class="mr-2" type="date" label="Check-IN Inicial"
              v-model="filtroDataInicial"
              data-cy="input-checkin-filtro"
              style="max-width: 160px;"
            ></v-text-field>
            <!-- Data Final -->
            <v-text-field class="mr-2" type="date" label="Check-IN Final"
              v-model="filtroDataFinal"
              data-cy="input-checkout-filtro"
              style="max-width: 160px;"
            ></v-text-field>
            <div style="display:flex;justify-content:center;padding:15px;">
              <!-- Botão Pesquisar -->
              <v-btn @click="loadPagamentos()" small color="primary" class="mx-2" :disabled="textoBtnPequisar != 'Pesquisar'"
                style="color:white;min-height:40px;font-weight:bold;"
                data-cy="btn-pesquisar"
              >
                <v-icon color="white" v-if="textoBtnPequisar == 'Pesquisar'">mdi-magnify</v-icon>
                {{textoBtnPequisar}}
              </v-btn>
              <!-- Botão Limpar Filtros -->
              <v-btn @click="limparFiltro()" small color="warning" class="mx-2" 
                data-cy="btn-limpar"
                style="color:white;min-height:40px;font-weight:bold;">
                <v-icon color="white">mdi-broom</v-icon>
                Limpar Filtros
              </v-btn>
            </div>
          </v-row>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          />
          <!-- Dados -->
          <v-data-table
            :headers="headers"
            :items="pagamentos"
            :footer-props="footerProps"
            :search="search"
            class="elevation-1"
            data-cy="tabela-pagamentos-checkinpay"
          >
            <template v-slot:[`footer.page-text`]="items"> 
              {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
            </template>
            <template v-slot:[`item.datacriacao`]="{ item }">
              {{item.datacriacao | formatarDataYYHora}}
            </template>
            <template v-slot:[`item.datacheckinprevisto`]="{ item }">
              {{item.datacheckinprevisto | formatarDataYYHora}}
            </template>
            <template v-slot:[`item.datacheckoutprevisto`]="{ item }">
              {{item.datacheckoutprevisto | formatarDataYYHora}}
            </template>
            <template v-slot:[`item.valor`]="{ item }">
              <div class="item-value">{{item.valor | formatarMoeda}}</div>
            </template>
            <template v-slot:[`item.valoraberto`]="{ item }">
              <div class="item-value">{{item.valoraberto | formatarMoeda}}</div>
            </template>
            <template v-slot:[`item.valorpago`]="{ item }">
              <div class="item-value">{{item.valorpago | formatarMoeda}}</div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="item-group">
                <div class="item-action" title="Documentos do hóspede"
                  @click="exibirModalDocumentos(item)">
                  <v-icon small color="black" class="mx-1 ponteiro">
                    mdi-file-document-multiple-outline</v-icon>Documentos
                </div>
                <div class="item-action" title="Itens de consumo."
                  @click="carregarItens(item)">
                  <v-icon small color="purple" class="mx-1 ponteiro">
                    mdi-format-list-bulleted</v-icon>Itens
                </div>
                <div class="item-action" title="Confirmar pagamento."
                  @click="confirmarBaixa(item)" v-if="item.statustransacao !== 4">
                  <v-icon small color="green" class="mx-1">
                    mdi-check</v-icon>Baixar
                </div>
                <div class="item-action" title="Histórico de pagamentos."
                  @click="carregarHistorico(item)">
                  <v-icon small color="blue" class="mx-1">
                    mdi-playlist-check</v-icon>Histórico
                </div>
                <div class="item-action" title="Estornar pagamento."
                  @click="confirmarEstorno(item)" v-if="item.statustransacao !== 5">
                  <v-icon small color="red" class="mx-1">
                    mdi-close</v-icon>Estornar
                </div>
              </div>
            </template>
          </v-data-table>
          <!-- Ítens do Pagamento -->
          <pagamentos-itens :items="itens" :show="mostrarItens" @closeitems="fecharItens" />
          <!-- Histórico do Pagamento -->
          <pagamentos-historico :items="historico" :show="mostrarHistorico" @closeitems="fecharHistorico" />
          <!-- Confirmar Baixa de Pagamento -->
          <pagamentos-confirmar :show="mostrarBaixa" 
            :titulo="'Confirmar baixa do pagamento'"
            :texto="'Clique em confirmar para baixar este pagamento.'"
            @confirmar="baixarPagamento" @cancelar="mostrarBaixa=false" />
          <!-- Confirmar Estorno de Pagamento -->
          <pagamentos-confirmar :show="mostrarEstorno" 
            :titulo="'Confirmar estorno do pagamento'"
            :texto="'Clique em confirmar para estornar este pagamento.'"
            @confirmar="estornarPagamento" @cancelar="mostrarEstorno=false" />
          <!-- Snack -->
          <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
              <div style="display:flex;align-items:center;align-content:center;justify-content:space-between;">
                <span>{{ snackText }}</span>
                <v-btn style="background-color:white;color:grey;" @click="snack = false">FECHAR</v-btn>
              </div>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="uploadDocs" 
      width="1000" max-width="70vw">
      <ModalTiposDocumentosHospedeCheckinCheckoutVue v-if="passo == 'selecionar'" @setarPasso="(valor) => setPasso(valor)" 
        @fechar="toggleDocs()"
      ></ModalTiposDocumentosHospedeCheckinCheckoutVue>

      <ModalDocumentosCapturadosCheckinCheckoutVue v-if="passo == 'cartao' || passo === 'comprovante' || passo ==  'documento'" @setarPasso="(valor) => setPasso(valor)" 
        @fechar="toggleDocs()" :item="itemSelecionado" :tipoDoc="passo"
      ></ModalDocumentosCapturadosCheckinCheckoutVue>
    </v-dialog>
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import PagamentosItens from './PagamentosItens.vue';
import PagamentosHistorico from './PagamentosHistorico.vue';
import PagamentosConfirmar from './PagamentosConfirmar.vue';
import BotaoTutorial from '../material/BotaoTutorial.vue';
import ModalTiposDocumentosHospedeCheckinCheckoutVue from '../DashViews/Modals/ModalTiposDocumentosHospedeCheckinCheckout.vue';
import ModalDocumentosCapturadosCheckinCheckoutVue from '../DashViews/Modals/ModalDocumentosCapturadosCheckinCheckout.vue';
export default {
  name:"PagamentosBaixa",
  components: { PagamentosItens, PagamentosHistorico, PagamentosConfirmar, BotaoTutorial, ModalTiposDocumentosHospedeCheckinCheckoutVue, ModalDocumentosCapturadosCheckinCheckoutVue },
  data: () => ({
    passo: '',
    listadestatus:[
      {id:1,nome:'Iniciado'},
      {id:2,nome:'Não Concluido'},
      {id:3,nome:'Finalizado'},
      {id:4,nome:'Baixado'},
      {id:5,nome:'Estornado'}
    ],
    filtroStatusPagto:{id:3,nome:"Finalizado"},
    filtroReserva: null,
    filtroNome: null,
    filtroSobrenome: null,
    filtroDataInicial: null,
    filtroDataFinal: null,
    snack: false,
    snackColor: "",
    snackText: "",
    pagamentos: [],
    footerProps: {
      'items-per-page-options': [15,20,25,{ text: "Todas", value: -1 }],
      'items-per-page-text': 'Linhas por página',
    },
    dialog: false,
    search: "",
    headers: [
      { text: "Nome", value: "nome" },
      { text: "Sobrenome", value: "sobrenome" },
      { text: "Reserva", value: "numeroreserva" },
      { text: "DT Pagto", value: "datacriacao" },
      { text: "Checkin", value: "datacheckinprevisto" },
      { text: "Checkout", value: "datacheckoutprevisto" },
      { text: "Valor", value: "valor", align: 'end' },
      // { text: "Valor em Aberto", value: "valoraberto", align: 'end' },
      // { text: "Pagamento", value: "valorpago", align: 'end' },      
      { text: "Ações", value: "actions", sortable: false, align: 'center' }
    ],
    editedIndex: -1,
    editedItem: {},
    textoBtnPequisar: 'Pesquisar',
    itens: [],
    mostrarItens: false,
    historico: [],
    mostrarHistorico: false,
    mostrarBaixa: false,
    itemABaixar: {},
    mostrarEstorno: false,
    itemAEstornar: {},
    uploadDocs: false,
    itemSelecionado: null,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.loadPagamentos();
  },
  methods: {
    setPasso(valor) {
      console.log(valor)
      this.passo = valor;
    },
    toggleDocs(passo) {
      this.uploadDocs = !this.uploadDocs
      if (passo) {
        this.passo = passo
      }
    },
    exibirModalDocumentos(items) {
      this.passo = 'selecionar'
      this.itemSelecionado = items;
      this.uploadDocs = true;
    },
    carregarItens(item) {
      var params = {idpagamento: item.id}
      this.$http.post("/checkinpay/getItensPagamentos", params)
      .then((response) => {
        if (response.status == 200) {
          this.itens = response.data
          this.mostrarItens = true
        } else {
          console.error(response)
        }
      })
      .catch((error) => {          
        console.log(error)
      });
    },
    fecharItens() {
      this.itens = []
      this.mostrarItens = false
    },
    carregarHistorico(item) {
      console.log(item)
      var params = {idpagamento: item.id}
      this.$http.post("/checkinpay/getDetalhePagamentos", params)
      .then((response) => {
        if (response.status == 200) {
          this.historico = response.data
          this.mostrarHistorico = true
        } else {
          console.error(response)
        }
      })
      .catch((error) => {          
        console.log(error)
      });
    },    
    fecharHistorico() {
      this.historico = []
      this.mostrarHistorico = false
    },
    confirmarBaixa(item) {
      this.itemABaixar = item
      this.mostrarBaixa = true
    },
    baixarPagamento() {
      var params = {
        "idpagamento": this.itemABaixar.id
      }
      this.$http.post("/checkinpay/baixarPagamento", params)
      .then((response) => {
        if (response.status == 200) {
          this.snackText = 'Pagamento baixado.'
          this.snackColor = 'green'
          this.snack = true
          this.loadPagamentos()
        } else {
          console.error(response)
        }
        this.mostrarBaixa = false
      })
      .catch((error) => {          
        console.log(error)
        this.mostrarBaixa = false
      });
    },
    confirmarEstorno(item) {
      this.itemAEstornar = item
      this.mostrarEstorno = true
    },    
    estornarPagamento() {
      var params = {
        idhotel: this.itemAEstornar.idhotel,
        idpagamento: this.itemAEstornar.id,
        tipotransacao: this.itemAEstornar.tipotransacao,

      }
      console.error(params)
      this.$http.post("/checkinpay/estornarPagamento", params)
      .then((response) => {
        if (response.status == 200) {
          this.snackText = 'Pagamento estornado.'
          this.snackColor = 'green'
          this.snack = true
          this.loadPagamentos()
        } else {
          console.error(response)
        }
        this.mostrarEstorno = false
      })
      .catch((error) => {          
        console.log(error)
        this.mostrarEstorno = false
      });
    },    
    limparFiltro() {
      this.filtroReserva = null
      this.filtroNome = null
      this.filtroSobrenome = null
      this.filtroDataInicial = null
      this.filtroDataFinal = null
    },
    loadPagamentos() {
      this.textoBtnPequisar = "Pesquisando..."

      if(!this.filtroDataInicial && !this.filtroReserva && !this.filtroNome && !this.filtroSobrenome){
        this.filtroDataInicial = dayjs().format('YYYY-MM-DD')
      }
      if(!this.filtroDataFinal && !this.filtroReserva && !this.filtroNome && !this.filtroSobrenome){
        this.filtroDataFinal = dayjs().format('YYYY-MM-DD')
      }

      var params = {
          datacheckoutinicial: this.filtroDataInicial,
          datacheckoutfinal: this.filtroDataFinal,
          statuspagamento: parseInt(this.filtroStatusPagto.id),
          nome: this.filtroNome,
          sobrenome: this.filtroSobrenome,
          numeroreserva: parseInt(this.filtroReserva)
      }
      console.log('params', JSON.stringify(params))
      try {
        //console.error(params)
        this.$http
        .post("/checkinpay/getPagamentos",params)
        .then((response) => {
          if (response.status == 200) {
            // TODO: substituir o array por response.data...
            this.pagamentos = response.data
          }
        })
        .catch((error) => {          
          console.log(error)
          alert('error')
        });
      } finally {
          this.textoBtnPequisar = "Pesquisar"
          // this.pagamentos = [
          //   {
          //     nome: 'Fulano de tal',
          //     reserva: '32145654',
          //     datacheckinprevisto: '2021-10-01 10:00',
          //     datacheckoutprevisto: '2021-10-07 16:00',
          //     valortotal: '120.50',
          //     valoremaberto: '11227.1',
          //     pagamento: '.59'
          //   },
          //   {
          //     nome: 'Ciclano de tal',
          //     reserva: '34446754',
          //     datacheckinprevisto: '2021-10-02 12:00',
          //     datacheckoutprevisto: '2021-10-09 16:00',
          //     valortotal: '1212420',
          //     valoremaberto: '0',
          //     pagamento: '2020'
          //   },
          //   {
          //     nome: 'Beltrano de tal',
          //     reserva: '34111759',
          //     datacheckinprevisto: '2021-10-06 12:00',
          //     datacheckoutprevisto: '2021-10-12 16:00',
          //     valortotal: '3224.20',
          //     valoremaberto: '1004.29',
          //     pagamento: '2024'
          //   },
          // ];
      }
    },
    focus(id) {
      var idEl = document.getElementById(id)
      if (idEl) idEl.focus()
    },
    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.editedItem = Object.assign({}, item);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    fecharAtualizacao() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveInline() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Registro salvo com Sucesso!";
    },
    cancelInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Operação Cancelada";
    },
    reset() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data reset to default";
    },
    openInline() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    errorSave() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Erro ao salvar usuário";
    },
    closeInline() {
      console.log("Dialog closed");
    },
  },
};
</script>
<style scoped>
.item-group{
  display: flex;
  flex-direction: row;
}
.item-action{
  cursor: pointer;
  font-size: 0.7rem!important;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}
.item-value{
  font-size: 0.8rem!important;
}
</style>